<template>
  <v-app class="my-background">
    <app-bar></app-bar>
    <v-content>
      <router-view/>
    </v-content>
    <Footer></Footer>
  </v-app>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue';
import AppBar from './components/AppBar.vue';
import Footer from './components/Footer.vue';

export default {
  name: 'App',
  components: {
    // HelloWorld,
    AppBar,
    Footer,
  },
  data: () => ({
    //
  }),
};
</script>
<style>
.my-background {
  background: linear-gradient(155deg, #f5a925 55%, rgb(0, 255, 255, 0.5) 100%);
}
</style>
